export const SMALL = 480
export const MEDIUM = 720
export const LARGE = 960
export const XLARGE = 1440
